import { useState, useEffect } from 'react'
import HelloSign from 'hellosign-embedded';
import {
  ApplicationBodyContainer,
  ApplicationBodyContent,
  DefaultTitle,
  DefaultSubtitle,
  FormContainer
} from 'src/components/application/defaultComponents'
import PrebuiltRenewalFooter from 'src/components/application/PrebuiltRenewalFooter'
import { useRenewal } from 'src/context/renewal'
import { appconfig } from 'src/config'
import { api } from 'src/services/apiClient'

const Signature = () => {
  const { renewalData } = useRenewal()
  const [helloSignDiv, setHelloSignDiv] = useState<HTMLDivElement | null>(null)
  const [alreadySignedMessage, setAlreadySignedMessage] = useState(false)
  const [alreadySigned, setAlreadySigned] = useState(false)

  useEffect(() => {
    const startHelloSign = async () => {
      if(!!helloSignDiv) {
        try {
          const { data } = await api.get('/Sign/Renewal/GetSignUrl?type=1')

          const client = new HelloSign()

          client.open(data, {
            clientId: appconfig.HELLOSIGN_CLIENT_ID,
            skipDomainVerification: true,
            allowCancel: false,
            hideHeader: true,
            container: helloSignDiv
          });

          client.on('sign', () => {
            setAlreadySigned(true)
            setAlreadySignedMessage(true)
          })
          
        } catch(_) {
          setAlreadySigned(true)
          setAlreadySignedMessage(true)
        }
      }
    }

    startHelloSign()
  }, [helloSignDiv])

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent>
        <DefaultTitle>Please sign your Warranty, Subscriber’s Agreement, and Power of Attorney</DefaultTitle>
        <DefaultSubtitle>Please read and sign the following agreement.</DefaultSubtitle>
        <FormContainer maxWidth='100%'>
          {alreadySignedMessage ? (
            <DefaultSubtitle>Your document signatures are complete. Click “Submit Application” below to complete your application process.</DefaultSubtitle>
          ) : (
            <div ref={setHelloSignDiv} style={{width: '100%', height: '600px'}}></div>
          )}
        </FormContainer>
      </ApplicationBodyContent>
      <PrebuiltRenewalFooter 
        goBackRoute="/customer/renew/judge/review/questions"
        isFormValid={alreadySigned}
        isCompleteApplicationAvailable={true}
        updatedApplication={renewalData}
      />
    </ApplicationBodyContainer>
  )
}

export default Signature

